const manageMail = {
  manageMail: {
    pageTitle: 'Manage Mail',
    description: 'Manage and customize email recipients, including registration, editing, deletion, and mail delivery status.',
    tabs: {
      schedule: 'Schedule Recipients',
      payment: 'Payment Recipients',
      inquiry: 'Inquiry Recipients'
    },
    searchPlaceholder: 'Search',
    buttons: {
      delete: 'Delete',
      add: 'Add',
      cancel: 'Cancel'
    },
    deleteModal: {
      title: 'Delete Recipient(s)',
      body: 'Are you sure you want to delete the selected recipient(s)? This operation cannot be undone.'
    },
    categories: {
      guideTitle: 'Mail category guide',
      schedule:
        'Receives all reservation and scheduled mail notifications for this service.',
      payment: 'Receives mail related to payments, billing, and transactions.',
      inquiry: 'Receives inquiry, support, and contact-related mail.',
      passResult: 'Receives result mail when a communication (pass) session has finished.'
    },
    addModal: {
      categorySelectHint: 'Select a category on the left to see a short description.'
    }
  }
};

export default manageMail;